import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  HostBinding,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { Header } from './shared/components/header/header';
import {
  BrFooter,
  BrFooterLegal,
} from '@govbr-ds/webcomponents-angular/standalone';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { DatePickerConf } from './core/config/date-picker.conf';

import { GlobalMessageComponent } from './shared/components/global-message/global-message.component';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { Title } from './shared/components/title/title';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SimulationBannerComponent } from './shared/components/simulation-banner/simulation-banner.component';
import { AuthService } from './shared/services/auth.services';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Header,
    Title,
    BrFooter,
    BrFooterLegal,
    GlobalMessageComponent,
    FormsModule,
    LoadingComponent,
    CommonModule,
    SimulationBannerComponent,
  ],
  providers: [provideFlatpickrDefaults(new DatePickerConf())],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);

  @HostBinding('attr.translate')
  readonly traduzir = 'no';

  @HostBinding('class.notranslate')
  readonly classeNaoTraduzir = true;

  title = 'Plataforma de Gerenciamento de Programas de Provimento - PGP';

  crumbs: { label: string; url?: string; active?: boolean }[] = [];
  showHeader = true;
  showFooter = true;

  ngAfterViewInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.activatedRoute;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        const breadcrumb = this.resolveBreadcrumb(currentRoute);
        if (breadcrumb.length > 0) {
          this.crumbs = breadcrumb.map((item, index) => ({
            ...item,
            active: breadcrumb.length - 1 === index,
          }));
        } else {
          this.crumbs = [];
        }
        const path = currentRoute.snapshot.routeConfig?.path;
        if (path === 'login' || path === 'ouvidoria') {
          this.showHeader = false;
          this.showFooter = false;
        } else {
          this.showHeader = true;
          this.showFooter = true;
        }
      });
  }

  private resolveBreadcrumb(route: ActivatedRoute): { label: string; url?: string }[] {
    const breadcrumbByRole = route.snapshot.data['breadcrumbByRole'] as
      | {
          role: string;
          breadcrumb: { label: string; url?: string }[];
        }[]
      | undefined;

    if (breadcrumbByRole) {
      const byRole = breadcrumbByRole.find((config) => this.authService.hasRole(config.role));
      if (byRole) {
        return byRole.breadcrumb;
      }
    }

    return (route.snapshot.data['breadcrumb'] as { label: string; url?: string }[] | undefined) ?? [];
  }
}
